export const navigator = (): Navigator => window.navigator;
